export type DetailsCardState = {
  brand: string | null;
  complete: boolean;
};

export const EMPTY_DETAILS_CARD_STATE: DetailsCardState = {
  brand: null,
  complete: false,
};
